import { mapState } from 'pinia'
import { useRootStore } from '@/store/root'
import { formatMoneyWithCurrency } from '@/plugins/numformat'
import { OrderStatus } from '@bigbank/dc-common/clients/http/account/modules/pending-payments/pending-payment.types'

const statusColors = {
  [OrderStatus.Confirmed]: 'f-color-mint',
  [OrderStatus.Completed]: 'f-color-mint',
  [OrderStatus.Failed]: 'f-color-red',
  [OrderStatus.Cancelled]: 'f-color-red'
}

export default {
  props: {
    pendingPayments: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      checkboxStates: {}
    }
  },
  computed: {
    ...mapState(useRootStore, ['locale', 'currency']),
    translations () {
      const signSelected = this.$pgettext('pending_payment_table', 'Accept / Sign selected')
      const sendMoney = this.$pgettext('pending_payment_table', 'Send money')
      const titleWaiting = this.$pgettext('pending_payment', 'Waiting for confirmation')
      const titleOther = this.$pgettext('pending_payment', 'Other')

      const confirm = this.isWaitingForConfirmation ? signSelected : sendMoney
      const title = this.isWaitingForConfirmation ? titleWaiting : titleOther

      return {
        title,
        button: {
          confirm,
          cancelSelected: this.$pgettext('pending_payment_table', 'Cancel selected payments'),
          edit: this.$pgettext('pending_payment_table', 'Edit'),
          delete: this.$pgettext('pending_payment_table', 'Delete'),
          close: this.$pgettext('pending_payment_table', 'Close')
        },
        row: {
          actions: this.$pgettext('pending_payment_table', 'Action buttons'),
          selection: this.$pgettext('pending_payment_table', 'Select rows'),
          subPaymentDetails: this.$pgettext('pending_payment_table', 'Payment details row')
        },
        table: {
          selectAllRows: this.$pgettext('pending_payment_table', 'Select all rows'),
          selectRow: this.$pgettext('pending_payment_table', 'Select row'),
          toggleDetails: this.$pgettext('pending_payment_table', 'Toggle details'),
          paymentDetails: this.$pgettext('pending_payment_table', 'Payment details')
        },
        footer: {
          totalAmount: this.$pgettext('pending_payment_table', 'Total amount'),
          totalPayments: this.$pgettext('pending_payment_table', 'Total payments')
        },
        column: {
          fromIban: this.$pgettext('pending_payment_table', 'From account'),
          orderDate: this.$pgettext('pending_payment_table', 'Payment date'),
          referenceNumber: this.$pgettext('pending_payment_table', 'Reference number'),
          description: this.$pgettext('pending_payment_table', 'Description'),
          amount: this.$pgettext('pending_payment_table', 'Amount'),
          orderStatus: this.$pgettext('pending_payment_table', 'Status'),
          acceptance: this.$pgettext('pending_payment_table', 'Acceptance'),
          recipientName: this.$pgettext('pending_payment_table', 'Recipient name'),
          recipientIban: this.$pgettext('pending_payment_table', 'Recipient IBAN')
        },
        status: {
          [OrderStatus.Confirmed]: this.$pgettext('pending_payment_table', 'Approved'),
          [OrderStatus.Completed]: this.$pgettext('pending_payment_table', 'Completed'),
          [OrderStatus.Failed]: this.$pgettext('pending_payment_table', 'Failed'),
          [OrderStatus.Cancelled]: this.$pgettext('pending_payment_table', 'Cancelled'),
          [OrderStatus.NotConfirmed]: this.$pgettext('pending_payment_table', 'Waiting confirmation')
        }
      }
    },
    hasTruthyCheckboxes () {
      return Object.values(this.checkboxStates).some(value => value)
    },
    sumAmount () {
      const selectedRows = this.pendingPayments.filter(p => this.checkboxStates[p.id])
      const amount = selectedRows.reduce((acc, row) => acc + row.amount, 0)

      return formatMoneyWithCurrency(amount, this.currency, this.locale)
    },
    isWaitingForConfirmation () {
      return this.pendingPayments.some(payment => payment.orderStatus === OrderStatus.NotConfirmed)
    },
    tableTestId () {
      return this.isWaitingForConfirmation ? 'pending-table-waiting-confirmation' : 'pending-table-other'
    }
  },
  watch: {
    pendingPayments: {
      handler (pendingPayments) {
        this.checkboxStates = pendingPayments.reduce((acc, payment) => {
          acc[payment.id] = null
          return acc
        }, {})
      },
      immediate: true
    }
  },
  methods: {
    onEdit (rowIndex) {
      alert(`edit row ${rowIndex}`)
    },
    onDelete (rowIndex) {
      alert(`delete row ${rowIndex}`)
    },
    getPaymentStatusColor (value) {
      return statusColors[value[0]] || 'f-color-gray'
    }
  }
}
